import { useState } from "react";
import { X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PIPELINE_STATUSES, PIPELINE_STATUS_LABELS, LOST_REASONS } from "@/lib/prospectMeta";

const inputCls = "w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-sm focus:border-[#0f2847] focus:ring-2 focus:ring-[#0f2847]/20 focus:outline-none";

export function StatusChangeModal({ prospect, targetStatus = "", onClose, onSaved }) {
  const name = prospect.institution_name || prospect.full_name;
  const [status, setStatus] = useState(targetStatus || prospect.status || "prospek_baru");
  const [catatan, setCatatan] = useState("");
  const [dealDate, setDealDate] = useState("");
  const [lostReason, setLostReason] = useState(LOST_REASONS[0]);
  const [lostNotes, setLostNotes] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/prospects/${prospect.id}/status`, {
        status_baru: status,
        catatan,
        deal_date: status === "berhasil" ? dealDate : "",
        lost_reason: status === "tidak_berhasil" ? lostReason : "",
        lost_notes: status === "tidak_berhasil" ? lostNotes : "",
      });
      toast.success("Status prospek diperbarui.");
      onSaved && onSaved();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Gagal mengubah status.");
    } finally { setSaving(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-start justify-center p-4 overflow-y-auto" data-testid="status-modal">
      <div className="bg-white rounded-xl w-full max-w-md mt-10 shadow-xl">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h2 className="font-semibold text-slate-900">Ubah Status</h2>
          <button onClick={onClose} className="p-1.5 rounded hover:bg-slate-100 text-slate-500" data-testid="status-modal-close"><X className="h-4 w-4" /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3" data-testid="status-modal-form">
          <p className="text-sm text-slate-500">Prospek: <span className="font-medium text-slate-800">{name}</span></p>
          <div>
            <label className="text-xs font-semibold text-slate-500 mb-1 block">Status Baru</label>
            <select className={inputCls} value={status} onChange={(e) => setStatus(e.target.value)} data-testid="status-select">
              {PIPELINE_STATUSES.map((s) => <option key={s} value={s}>{PIPELINE_STATUS_LABELS[s]}</option>)}
            </select>
          </div>
          {status === "berhasil" && (
            <div><label className="text-xs font-semibold text-slate-500 mb-1 block">Tanggal Deal</label><input type="date" className={inputCls} value={dealDate} onChange={(e) => setDealDate(e.target.value)} data-testid="status-deal-date" required /></div>
          )}
          {status === "tidak_berhasil" && (
            <>
              <div><label className="text-xs font-semibold text-slate-500 mb-1 block">Alasan</label><select className={inputCls} value={lostReason} onChange={(e) => setLostReason(e.target.value)} data-testid="status-lost-reason">{LOST_REASONS.map((r) => <option key={r} value={r}>{r}</option>)}</select></div>
              <div><label className="text-xs font-semibold text-slate-500 mb-1 block">Catatan Tambahan</label><textarea className={inputCls} rows={2} value={lostNotes} onChange={(e) => setLostNotes(e.target.value)} data-testid="status-lost-notes" /></div>
            </>
          )}
          <div><label className="text-xs font-semibold text-slate-500 mb-1 block">Catatan Singkat</label><textarea className={inputCls} rows={2} value={catatan} onChange={(e) => setCatatan(e.target.value)} data-testid="status-catatan" /></div>
          <div className="flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50" data-testid="status-cancel">Batal</button>
            <button type="submit" disabled={saving} className="inline-flex items-center gap-2 bg-[#0f2847] hover:bg-[#17416f] text-white text-sm font-medium px-4 py-2 rounded-lg" data-testid="status-submit">{saving && <Loader2 className="h-4 w-4 animate-spin" />} Simpan</button>
          </div>
        </form>
      </div>
    </div>
  );
}
